import ISO6391 from "iso-639-1";

// Languages with no ISO 639-1 code — validated manually against ISO 639-3
export const ISO6393_EXCEPTIONS = ["mos"] as const;

export const SUPPORTED_LANGUAGES = [
  "am",
  "ar",
  "zh",
  "en",
  "ee",
  "es",
  "fr",
  "ff",
  "ht",
  "ha",
  "hi",
  "ig",
  "rw",
  "kg",
  "ln",
  "mos",
  "om",
  "pt",
  "sn",
  "so",
  "sw",
  "ti",
  "tw",
  "wo",
  "xh",
  "yo",
  "zu",
] as const;

export type LanguageCode = (typeof SUPPORTED_LANGUAGES)[number];

export const LANGUAGE_NAMES: Partial<Record<string, string>> = {
  mos: "Mooré",
};

export function isValidLanguage(code: string): code is LanguageCode {
  return (
    (ISO6391.validate(code) ||
      (ISO6393_EXCEPTIONS as readonly string[]).includes(code)) &&
    (SUPPORTED_LANGUAGES as readonly string[]).includes(code)
  );
}

export function getLanguageName(code: string): string {
  return LANGUAGE_NAMES[code] || ISO6391.getNativeName(code);
}

export const languageOptions: ReadonlyArray<{
  code: LanguageCode;
  name: string;
}> = SUPPORTED_LANGUAGES.map((code) => ({
  code,
  name: getLanguageName(code),
}));
